<template>
  <footer>
    <div>
      <div class="address" v-html="$t('footer.address')">
      </div>
      <div class="contact">
        <template v-for="(entry, idx) in $t('footer.contacts')">
          <a v-if="entry.url" :key="`link-${idx}`" :href="entry.url">{{ entry.label }}</a>
          <span v-else :key="`span-${idx}`">{{ entry.label }}</span>
        </template>
      </div>
      <div class="socials" :class="{ vertical }">
        <a
          v-for="(entry,idx) in $t('footer.socials')"
          :key="`socials-${idx}`"
          :href="entry.url">
            <template v-if="socialIcons">
              <SVGInstagram v-if="entry.channel === 'instagram'" />
              <SVGFacebook v-if="entry.channel === 'facebook'"/>
              <SVGYoutube v-if="entry.channel === 'youtube'"/>
              <SVGTwitter v-if="entry.channel === 'twitter'"/>
            </template>
            <span v-if="socialLabel">{{ entry.label }}</span>
        </a>
      </div>
    </div>
  </footer>
</template>

<script>
  import SVGInstagram from '@/assets/svg/icon-socials-instagram.svg?inline';
  import SVGFacebook from '@/assets/svg/icon-socials-facebook.svg?inline';
  import SVGTwitter from '@/assets/svg/icon-socials-twitter.svg?inline';
  import SVGYoutube from '@/assets/svg/icon-socials-youtube.svg?inline';

  export default {
    name: 'Footer',
    components: {
      SVGInstagram,
      SVGFacebook,
      SVGTwitter,
      SVGYoutube,
    },
    //---------------------------------------------------
    //
    //  Properties
    //
    //---------------------------------------------------
    props: {},
    //---------------------------------------------------
    //
    //  Data model
    //
    //---------------------------------------------------
    data() {
      return {
        socialIcons: true,
        socialLabel: false,
        vertical: false,
      };
    },
    //---------------------------------------------------
    //
    //  Computed Properties
    //
    //---------------------------------------------------
    computed: {},
    //---------------------------------------------------
    //
    //  Watch Properties
    //
    //---------------------------------------------------
    watch: {},
    //---------------------------------------------------
    //
    //  Filter Properties
    //
    //---------------------------------------------------
    // filters: {},
    //---------------------------------------------------
    //
    //  Validation Properties
    //
    //---------------------------------------------------
    // validations: {},
    //---------------------------------------------------
    //
    //  Vue Lifecycle
    //
    //---------------------------------------------------
    // beforeCreate() {},
    // created() {},
    // beforeMount() {},
    // render(h) { return h(); },
    // mounted() {},
    // beforeUpdate() {},
    // updated() {},
    // beforeDestroy() {},
    // destroyed() {},
    //---------------------------------------------------
    //
    //  Methods
    //
    //---------------------------------------------------
    methods: {},
  };
</script>

<style lang="scss">
@import '~scss/mixins';
@import '~scss/variables';

footer {
  width: 100%;
  padding: 20px 0;
  background-color: black;
  color: white;
  font-size: 1.4rem;
  @include font-regular;

  & > div {
    display: flex;
    @include max-width-constraints;
    justify-content: space-between;
    align-items: center;

    @include screen-mobile {
      flex-direction: column;
      gap: 15px;
    }

    a {
      color: inherit;
      font-size: inherit;
      text-decoration: none;
    }

    & > .address {
      @include screen-mobile {
        text-align: center;
      }
    }

    & > .contact {
      text-align: center;
      & > span, & > a { display: block };
    }

    & > .socials {
      display: flex;
      flex-direction: row;
      gap: 5px;

      & > a {
        display: inline-flex;
        align-items: center;
        padding: 0 5px;

        & > svg {
          margin-right: 5px;

          &:only-child {
            margin-right: 0;
          }
        }
      }

      &.vertical {
        display: flex;
        flex-direction: column;
        gap: 5px;
      }
    }
  }
}

</style>
